export default __webpack_public_path__ + "img/floorplan-tooltip-arrow-left.svg";